
  document.addEventListener('DOMContentLoaded', function () {
    // const options_date = document.querySelectorAll('.options_date input');
    // const options_date_disabled = document.querySelectorAll('.options_date input.disabled');
    // if (options_date.length > 0) {
    //   options_date.forEach(input => {
    //     if(options_date_disabled.length == 0){
    //     if (input.hasAttribute('checked')) {
    //       input.removeAttribute('checked');
    //     }
    //     }else{
    //       const options_date_div = document.querySelector('.options_date'); // only first one
    //       if (options_date_div) {
    //         options_date_div.style.opacity = '0';
    //       }
    //     }
    //   });
    // }

const fullsetHover = document.querySelectorAll('.full-set__content span');
const tutorial = document.querySelector('.full-set__tutorial');
if (fullsetHover.length > 0 && tutorial) {
  fullsetHover.forEach(spans => {
    spans.addEventListener('mouseenter', () => {
      tutorial.classList.add('active');
    });
  });
}

const fullSettuTorial = document.querySelector('.full-set__tutorial');
if(fullSettuTorial){
   fullSettuTorial.addEventListener('mouseleave', () => {
    fullSettuTorial.classList.remove('active');
  });
}


const closeButtonsPopup = document.querySelectorAll('.product-popup-close');
if (closeButtonsPopup.length > 0) {
  closeButtonsPopup.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const popups = document.querySelectorAll('.product-popup');
      popups.forEach(popup => popup.classList.remove('active'));
      const productDetails = document.getElementById('productDetails');
      if (productDetails) {
        productDetails.classList.remove('popup_active_product_main');
      }
    });
  });
}

const noThanksButtons = document.querySelectorAll('.no_thanks');
if (noThanksButtons.length > 0) {
    noThanksButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const productDetails = document.getElementById('productDetails');
            if (productDetails) {
              productDetails.classList.remove('popup_active_product_main');
              productDetails.classList.add('add_to_cart_yes');
            }
            const popups = document.querySelectorAll('.product-popup'); // use plural
            if (popups.length) { // check if NodeList is not empty
                popups.forEach(popup => {
                    popup.classList.remove('active');
                });
            }
            const cartBtn = document.querySelector('.product-form__submit');
            if (cartBtn) {
                cartBtn.click();
            }
        });
    });
}


document.querySelectorAll('.popup_continue').forEach(function(button) {
    button.addEventListener('click', async function(e) {
        e.preventDefault();

        const var_id = this.getAttribute('data-id');
        const formData = {
            items: [{
                id: var_id,
                quantity: 1
            }]
        };

        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            await response.json();

            const productDetails = document.getElementById('productDetails');
            if (productDetails) {
              productDetails.classList.add('add_to_cart_yes');
            }
            const cartBtn = document.querySelector('.product-form__submit');
            if (cartBtn) {
                cartBtn.click();
            }

            document.querySelectorAll('.product-popup').forEach(function(popup) {
                popup.classList.remove('active');
            });

            if (productDetails) {
              productDetails.classList.remove('popup_active_product_main');
            }

        } catch (error) {
            console.error('Error:', error);
            alert('Something went wrong, please try again');
        }
    });
});




  function removeFoldClasses() {
    document.body.classList.remove('fold_option_active');
    const productDetail = document.querySelector('.fold_product_detail');
    if (productDetail) {
      productDetail.classList.remove('fold_product_option_active');
    }
  }

  // For .cross-icon
  const crossIcon = document.querySelector('.cross-icon');
  if (crossIcon) {
    crossIcon.addEventListener('click', removeFoldClasses);
  }

  // For .date-variant-options
  const dateVariant = document.querySelector('.date-variant-options');
  if (dateVariant) {
    dateVariant.addEventListener('click', removeFoldClasses);
  }

  const bodyClick = document.querySelector('body');
  if (bodyClick) {
    bodyClick.addEventListener('click', function () {
      if (document.body.classList.contains('fold_option_active')) {
        removeFoldClasses();
      }
    });
  }

  });

  // function updateVariantBannerImage() {
  //   const img = document.querySelector('.variant-banner__image');
  //   if (!img) return;
  //   const mobileSrc = img.getAttribute('data-mobile-src');
  //   const desktopSrc = img.getAttribute('data-desktop-src');
  //   const isDesktop = window.innerWidth >= 768;
  //   const newSrc = isDesktop ? desktopSrc : mobileSrc;

  //   if (newSrc && img.src !== newSrc) {
  //     img.src = newSrc;
  //   }
  // }
  // document.addEventListener('DOMContentLoaded', updateVariantBannerImage);
  // window.addEventListener('resize', updateVariantBannerImage);

var variant_url_check = new URLSearchParams(window.location.search).get("variant");
const customBtn = document.querySelectorAll('.custom_new_btn .item-variant-name');
if (customBtn.length > 0) { 
  customBtn.forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      customBtn.forEach(l => l.classList.remove('active_btn'));
      this.classList.add('active_btn');
      const dataName = this.getAttribute('data-name');

      if (dataName === 'chrono') {
        document.querySelector('.var-hide-show-color-list').classList.remove('color_gmt');
        document.querySelector('.size-variant').classList.remove('size_gmt');
        document.querySelector('.date-variant').classList.remove('date_gmt');
        const specificBtn = document.querySelector('.size-variant .item-variant[data-main-title="40mm"]');
        if (specificBtn) {
          specificBtn.click();
        }
        const specificDate = document.querySelector('.date-variant .item-variant[data-main-title="no-date"]');
        if (specificDate) {
          specificDate.click();
        }

      } else if (dataName === 'gmt') {
        document.querySelector('.var-hide-show-color-list').classList.add('color_gmt');
        document.querySelector('.size-variant').classList.add('size_gmt');
        document.querySelector('.date-variant').classList.add('date_gmt');
        const specificBtn = document.querySelector('.size-variant .item-variant[data-main-title="42-5mm"]');
          if (specificBtn) {
            specificBtn.click();
          }
          const specificDate = document.querySelector('.date-variant .item-variant[data-main-title="date"]');
          if (specificDate) {
            specificDate.click();
          }
        if(variant_url_check){
          variant_url_check = '';
        }else{
          setTimeout(function() {
            const colorList = document.querySelector('.color-image .item-variant.item-color[data-main-title="pepsi"]');
            if (colorList) {
              colorList.click();
            }
          }, 2000);
        }
      }
    });
  });
}

